import React, { useState } from 'react';
import { observer } from 'mobx-react-lite';
import { Button, Header, Modal, Icon, Segment, List, Divider } from 'semantic-ui-react';
import { useStore } from '../../app/stores/store';
// Import your translation function - adjust the import path as needed
import { useTranslation } from 'react-i18next'; // or your preferred i18n library

export default observer(function DeleteMyData() {
  const { profileStore } = useStore();
  const { t } = useTranslation(); // or your translation hook
  const [modalOpen, setModalOpen] = useState(false);
  const [confirmText, setConfirmText] = useState('');

  const handleDeleteAccount = async () => {
    if (confirmText.toLowerCase() === t('deleteMyData.modal.confirmPhrase')) {
      await profileStore.deleteAccount();
      setModalOpen(false);
    }
  };

  const isConfirmValid = confirmText.toLowerCase() === t('deleteMyData.modal.confirmPhrase');

  return (
    <Segment>
      <Header as="h2" color="red">
        <Icon name="warning sign" />
        {t('deleteMyData.title')}
      </Header>
      
      <div style={{ marginBottom: '20px' }}>
        <Header as="h3">{t('deleteMyData.dataRights.title')}</Header>
        <p>
          {t('deleteMyData.dataRights.description')}
        </p>
        
        <Header as="h4">{t('deleteMyData.whatWillBeDeleted.title')}</Header>
        <List bulleted>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.userAccount')}</List.Item>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.profilePictures')}</List.Item>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.gameHistory')}</List.Item>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.relationships')}</List.Item>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.locationData')}</List.Item>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.deviceInfo')}</List.Item>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.personalData')}</List.Item>
          <List.Item>{t('deleteMyData.whatWillBeDeleted.items.businessData')}</List.Item>
        </List>
        
        <Header as="h4" color="orange">{t('deleteMyData.importantNotes.title')}</Header>
        <List bulleted>
          <List.Item><strong>{t('deleteMyData.importantNotes.items.irreversible')}</strong></List.Item>
          <List.Item>{t('deleteMyData.importantNotes.items.loggedOut')}</List.Item>
          <List.Item>{t('deleteMyData.importantNotes.items.newAccount')}</List.Item>
          <List.Item>{t('deleteMyData.importantNotes.items.anonymizedData')}</List.Item>
        </List>
      </div>

      <Divider />

      <div style={{ textAlign: 'center', marginTop: '20px' }}>
        <Button 
          color="red" 
          size="large"
          onClick={() => setModalOpen(true)}
          disabled={profileStore.loading}
        >
          <Icon name="trash" />
          {t('deleteMyData.deleteButton')}
        </Button>
      </div>

      <Modal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        size="small"
      >
        <Modal.Header>
          <Icon name="warning sign" color="red" />
          {t('deleteMyData.modal.title')}
        </Modal.Header>
        
        <Modal.Content>
          <Header as="h3" color="red">
            {t('deleteMyData.modal.confirmTitle')}
          </Header>
          <p>
            {t('deleteMyData.modal.confirmDescription')}
          </p>
          
          <div style={{ 
            background: '#fff2f2', 
            padding: '15px', 
            border: '1px solid #e0b4b4',
            borderRadius: '4px',
            margin: '15px 0'
          }}>
            <p><strong>{t('deleteMyData.modal.permanentDeletion.title')}</strong></p>
            <List bulleted>
              <List.Item>{t('deleteMyData.modal.permanentDeletion.items.profile')}</List.Item>
              <List.Item>{t('deleteMyData.modal.permanentDeletion.items.photos')}</List.Item>
              <List.Item>{t('deleteMyData.modal.permanentDeletion.items.gameStats')}</List.Item>
              <List.Item>{t('deleteMyData.modal.permanentDeletion.items.connections')}</List.Item>
              <List.Item>{t('deleteMyData.modal.permanentDeletion.items.otherData')}</List.Item>
            </List>
          </div>

          <div style={{ marginTop: '20px' }}>
            <p>
              {t('deleteMyData.modal.confirmInstruction')}
            </p>
            <input
              type="text"
              placeholder={t('deleteMyData.modal.placeholder')}
              value={confirmText}
              onChange={(e) => setConfirmText(e.target.value)}
              style={{
                width: '100%',
                padding: '10px',
                border: '1px solid #ccc',
                borderRadius: '4px',
                fontSize: '14px'
              }}
            />
          </div>
        </Modal.Content>
        
        <Modal.Actions>
          <Button
            onClick={() => {
              setModalOpen(false);
              setConfirmText('');
            }}
          >
            <Icon name="remove" />
            {t('deleteMyData.modal.buttons.cancel')}
          </Button>
          <Button
            color="red"
            onClick={handleDeleteAccount}
            disabled={!isConfirmValid || profileStore.loading}
            loading={profileStore.loading}
          >
            <Icon name="trash" />
            {t('deleteMyData.modal.buttons.delete')}
          </Button>
        </Modal.Actions>
      </Modal>
    </Segment>
  );
});